export default "__VITE_ASSET__BPTZjops__"